export default __webpack_public_path__ + "static/media/ai.d059642f.svg";